import React from 'react';
import * as PhosphorIcons from '@phosphor-icons/react';
import { LockSimple as LockSimpleIcon } from '@phosphor-icons/react';

// Helper function to convert icon name to PascalCase
const toPascalCase = (str) => {
  if (!str || typeof str !== 'string') return 'Bug';
  return str
    .trim()
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join('');
};

// Known explicit imports to guard against tree-shaking or naming mismatches
const explicitIcons = {
  LockSimple: LockSimpleIcon,
};

// Alias map for any kebab-case names that may not directly convert
const nameAliases = {
  'lock-simple': 'LockSimple',
};

// Component to render Phosphor icons
const Icon = ({ name, size = 24, weight = "regular", ...props }) => {
  const originalName = typeof name === 'string' ? name : '';
  const normalizedKebab = originalName.trim().toLowerCase();
  const resolvedName = nameAliases[normalizedKebab] || toPascalCase(originalName);

  // Try to resolve from namespace first, then explicit imports
  const IconComponent = PhosphorIcons[resolvedName] || explicitIcons[resolvedName];

  if (!IconComponent) {
    return <PhosphorIcons.Bug size={size} weight={weight} {...props} />;
  }

  return <IconComponent size={size} weight={weight} {...props} />;
};

export default Icon; 